import React from "react";
import {IContainerProps} from "../../Interfaces/IContainterProps";
import {EmploymentRecordItem} from "./EmploymentRecord/EmploymentRecordItem";
import {CreateEmploymentRecord} from "./EmploymentRecord/CreateEmploymentRecord";
import {hasPermission} from "../../Utils/hasPermission";

interface IEmploymentRecordProps extends IContainerProps {
    style?: React.CSSProperties;
}

export const EmploymentRecord: React.FunctionComponent<IEmploymentRecordProps> = (props) => {
    const sortEmploymentRecord = [...props.item.employmentRecords!];

    const safeDate = (dateString: any) => dateString && new Date(dateString);

    sortEmploymentRecord.sort((a, b) => {
        if (a.to === null && b.to === null) return safeDate(b.from).getTime() - safeDate(a.from).getTime();
        if (a.to === null) return -1;
        if (b.to === null) return 1;
        if (a.to === b.to) return safeDate(b.from).getTime() - safeDate(a.from).getTime();
        return safeDate(b.to).getFullYear() - safeDate(a.to).getFullYear();
    });

    return (
        <div style={{paddingTop: 20, paddingLeft: 30, paddingRight: 46, width:'100%'}}>
            {hasPermission(props.item.userContext.permissions) &&
                <CreateEmploymentRecord patch={props.patch} id={props.item.id}/>
            }
            {sortEmploymentRecord.map( employment => <EmploymentRecordItem key={employment.id} permissions={props.item.userContext} employmentRecord={employment} patch={props.patch}  /> )}
        </div>
    );
};